import styled from '@emotion/styled';

export const ContentWrapper = styled.div`
    display: inline-flex;
    flex-wrap: wrap;
`;

export const RolesSelectionWrapper = styled.div`
    display: grid;
    grid-template-columns: 100%;
`;

export const FolderParentName = styled.span`
    font-size: small;
    font-weight: bold;
`;

export const RolesOnFolder = styled.span`
    font-size: small;
`;

export const ParentRolesWrapper = styled.div`
    display: block;
    margin-bottom: 1rem;
`;

export const SearchFieldWrapper = styled.div`
    width: 100%;
    padding-bottom: 10px;
`;

export const BoxDiv = styled.div`
    width: 100%;
    height: 150px;
    // overflow-x: hidden;
    overflow-y: scroll;
    border: 1px solid grey;
    margin-top: 1rem;
`;

export const CheckboxDiv = styled.div`
    padding-bottom: 10px;
`;

export const Label = styled.label`
    display: inline-block;
    width: 100%;
`;

export const RoleListLabel = styled.label`
    display: inline-block;
    width: 100%;
    margin-top: 1rem;
    font-size: small;
    font-weight: bold;
`;
